/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { PaginatorSelectComponent } from 'src/app/components/paginatorselect/paginatorselect.component';
import { MatTableDataSource } from '@angular/material/table';
import {
  RequestHistory,
  SummaryItem,
} from '../my-requests/commons/interfaces/my-requests.interface';
import { RequestsService } from '../../home/services/requests.service';
import { CommmonService } from 'src/app/utils/common.service';
import { MatDialog } from '@angular/material/dialog';
import { STATUS_REQUEST } from '../my-requests/commons/constans/my-requests.constants';

@Component({
  selector: 'app-tab-requests',
  templateUrl: './tab-requests.component.html',
  styleUrls: ['./tab-requests.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed,void', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'),
      ),
    ]),
  ],
})
export class TabRequestsComponent implements OnInit {
  @ViewChild(PaginatorSelectComponent, { static: false })
  childC!: PaginatorSelectComponent;
  dataSource!: MatTableDataSource<RequestHistory>;
  columnsToDisplay = ['name', 'rut', 'benefit', 'idCode', 'createdAt', 'chip'];
  columnsToDisplayWithExpand = [...this.columnsToDisplay, 'expand'];
  expandedElement!: RequestHistory | null;
  steps = [];
  requests!: RequestHistory[];
  paginatedRequests!: RequestHistory[];
  searchTerm = '';
  isSizeMobile = false;
  totalPages!:number;
  totalRows!: number;
  itemsPerPage = 15;
  currentPage = 1;
  rejected: RequestHistory[] = [];
  aproved: RequestHistory[] = [];
  sended: RequestHistory[] = [];
  withError: RequestHistory[] = [];
  cancel:RequestHistory[] = [];
  summaryItems: SummaryItem[] = [];
  name!: string;
  openModal = false;
  filterLabel = '';
  filteredRequestsData: RequestHistory[]=[]
  filteredRequestsOnSearch:RequestHistory[]=[]

  constructor(
    private requestsService: RequestsService,
    private commonService: CommmonService,
    public dialog: MatDialog,
  ) {}

  async ngOnInit(): Promise<void> {
    await this.getRequests();
    this.userName();
    this.dataSource = new MatTableDataSource(this.paginatedRequests);
    this.updateSummaryItems();
  }

  updateSummaryItems() {
    this.summaryItems = [
      {
        label: 'Recibidas',
        value: this.sended.length,
        description: 'En total',
      },
      {
        label: 'Aprobadas',
        value: this.aproved.length,
        description: 'Últimos 30 días',
      },
      {
        label: 'Rechazadas',
        value: this.rejected.length,
        description: 'Últimos 30 días',
      },
      {
        label: 'Con error',
        value: this.withError.length,
        description: 'Últimos 30 días',
      },
      {
        label: 'Anuladas',
        value: this.cancel.length,
        description: 'Últimos 30 días',
      }
    ];
  }

  userName() {
    const activeUser = (this.name = JSON.parse(
      this.commonService.getItemSessionStorage('id_token_claims_obj') ?? '{}',
    ));
    this.name = activeUser.name;
  }

  async getRequests() {
    this.requests = await this.requestsService.getRequestAdministrator();
    this.requests = this.requests.map((req) => {
      if (req.status === 'Enviada') {
        return { ...req, status: 'Recibida' };
      }
      return req;
    }); 
    this.requests.sort((a, b)=> b.idCode - a.idCode)
    this.sended = this.requests.filter(
      (request) => request.status === 'Recibida',
    );
    let request_filtro30dias = this.filtrarFechas(this.requests);
    
    this.rejected = request_filtro30dias.filter(
      (request) => request.status === 'Rechazada',
    );

    this.aproved = request_filtro30dias.filter(
      (request) => request.status === 'Aprobada',
    );
    
    this.withError = request_filtro30dias.filter(
      (request) => request.status === 'Con error',
    );
    this.cancel = request_filtro30dias.filter((req)=> req.status === 'Anulada');

    this.dataSource = new MatTableDataSource(this.requests);
    this.totalPages = Math.ceil(this.requests.length / this.itemsPerPage);
    this.totalRows = this.requests.length;
    this.paginateRequests(1, this.requests);
    this.childC.getNumberPagesPaginatorSelect(this.currentPage, this.totalPages);
  }

  filtrarFechas(arregloObjetos:any[]) {
    const fechaActual = new Date();
    const fechaLimite = new Date();
    fechaLimite.setDate(fechaActual.getDate() - 30); 
   
    return arregloObjetos.filter(req=> {
      const partesFecha = req.createdAt.split('-'); 
      const fechaObjeto = new Date(
        parseInt(partesFecha[2]), // Año
        parseInt(partesFecha[1]) - 1, // Mes (0-11)
        parseInt(partesFecha[0]) // Día
      );
                     
      return fechaObjeto >= fechaLimite;
    });
  }

  paginateRequests(page: number, request: RequestHistory[]) {
    this.paginatedRequests = request.slice(
      (page - 1) * this.itemsPerPage,
      page * this.itemsPerPage,
    );
  }

  filterByLabel(label: string) {
    if (this.filterLabel !== label) {
      this.filterLabel = label;
      switch (this.filterLabel) {
        case 'Recibidas':
          this.filteredRequestsData = this.sended;   
          this.currentPage = 1 ; 
          break;
        case 'Aprobadas':
          this.filteredRequestsData = this.aproved;
          this.currentPage = 1 ; 
          break;
        case 'Rechazadas':
          this.filteredRequestsData = this.rejected;
          this.currentPage = 1 ; 
          break;
        case 'Con error':
          this.filteredRequestsData = this.withError;
          this.currentPage = 1 ; 
          break;
        case 'Anuladas':
          this.filteredRequestsData = this.cancel;
          this.currentPage = 1 ; 
          break;
        default:
          this.filteredRequestsData = this.requests;
          this.currentPage = 1 ; 
          break;
      }
    }else{
      this.filterLabel=''
      this.currentPage =1
      this.filteredRequestsData = this.requests;
    }
    
    this.totalPages = Math.ceil(this.filteredRequestsData.length / this.itemsPerPage);
    this.totalRows = this.filteredRequestsData.length;
    this.paginateRequests(1, this.filteredRequestsData);
    this.childC.getNumberPagesPaginatorSelect(this.currentPage, this.totalPages);
  }

  onSearch() {
    this.filteredRequestsOnSearch = this.requests;
    if (this.searchTerm.length >= 1) {
      this.filteredRequestsOnSearch = this.filterRequests(this.filteredRequestsOnSearch, this.searchTerm);
    }else{
      this.currentPage = 1; 
    }

    this.totalPages = Math.ceil(this.filteredRequestsOnSearch.length / this.itemsPerPage);
    this.paginateRequests(1, this.filteredRequestsOnSearch);
    this.childC.getNumberPagesPaginatorSelect(this.currentPage, this.totalPages);
  }

  filterRequests(
    requests: RequestHistory[],
    searchTerm: string,
  ): RequestHistory[] {
    const normalizedSearchTerm = this.normalizeString(searchTerm.toLowerCase());
    return requests.filter(
      (request) =>
        this.includesNormalized(
          request.idCode?.toString(),
          normalizedSearchTerm,
        ) ||
        this.includesNormalized(request.benefit, normalizedSearchTerm) ||
        this.includesNormalized(request.createdAt, normalizedSearchTerm) ||
        this.includesNormalized(request.name, normalizedSearchTerm) ||
        this.includesNormalized(request.rut, normalizedSearchTerm)||
        this.includesNormalized(request.status, normalizedSearchTerm),
    );
  }

  normalizeString(str: string): string {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  includesNormalized(source: string | undefined, searchTerm: string): boolean {
    return source
      ? this.normalizeString(source.toLowerCase()).includes(searchTerm)
      : false;
  }

  onSelecPageChange(event: Event) {
    const itemsPerPages1 = (event.target as HTMLInputElement).value;
    this.itemsPerPage = Number(itemsPerPages1);
    this.currentPage = 1;
    this.totalPages = Math.ceil(this.requests.length / this.itemsPerPage);
    this.paginateRequests(1, this.requests);
    this.childC.getNumberPagesPaginatorSelect(this.currentPage, this.totalPages);
  }

  trackByFn(index: number, item: any): any {
    return item.position;
  }

  getIconStatus(status: string): string {
    switch (status) {
      case 'Recibida':
        return '/assets/icon-request-status/recieved-status.svg';
      case 'Aprobada':
        return '/assets/icon-request-status/aprove-status.svg';
      case 'Con error':
        return '/assets/icon-request-status/error-status.svg';
      case 'Rechazada':
        return '/assets/icon-request-status/reject-status.svg';
      case 'Anulada':
        return '/assets/icon-summary/anulada.svg';
      case 'Espera 2° aprobación':
          return '/assets/icon-request-status/second_approver.svg';
      default:
        return '/assets/icon-request-status/recieved-status.svg';
    }
  }

  writeColumn(status: string): string {
    switch (status) {
      case 'benefit':
        return STATUS_REQUEST.BENEFIT;
      case 'idCode':
        return STATUS_REQUEST.COD_OPERATION;
      case 'createdAt':
        return STATUS_REQUEST.DATE;
      case 'rut':
        return STATUS_REQUEST.RUT;
      case 'name':
        return STATUS_REQUEST.NAME;
      default:
        return '';
    }
  }

  onPageChange(page: any) {
   
    let data = this.requests;
    if(this.filterLabel === '' && this.filteredRequestsOnSearch.length === 0){
      data= this.requests       
    }else if(this.filterLabel !== '') {
      data = this.filteredRequestsData
    }else if(this.filteredRequestsOnSearch.length !== 0){
      data = this.filteredRequestsOnSearch
    }
    this.currentPage = page;
    this.paginateRequests(this.currentPage, data);
  }
}
